import mapboxgl from 'mapbox-gl'

export default {
  name: 'map',
  component() {
      return {
        map: null,
        markers: [],
        locations: [],
        visibleLocations: [],
        searchTerm: '',
        searchBox: null,
        center: null,
        userLocation: false,
      
        init() {
          // Get locations data from the DOM
          this.getLocationsData()
          this.setMap()

          // console.log(navigator.geolocation.getCurrentPosition(this.success, this.error));
          // this.$watch('$store.search.view',(value,oldvalue)=>{
          //   document.getElementById('map').style.opacity = 0;

            // setTimeout(() => {
            //   this.setMarkers();
            // }, 50);

            // setTimeout(() => {
            //   document.getElementById('map').style.opacity = 1;
            // }, 150);
          // });

          // window.addEventListener('update-map-markers', (event) => {
          //   this.setMarkers(event && event.detail && event.detail.zoom === false ? false : true)
          // })
        },

        getLocationsData() {
          // Get all location elements and extract their data
          const locationElements = document.querySelectorAll('[data-location]');
          this.locations = Array.from(locationElements).map(el => {
            return {
              name: el.dataset.name || '',
              address: el.dataset.address || '',
              phone: el.dataset.phone || '',
              longitude: parseFloat(el.dataset.longitude) || 0,
              latitude: parseFloat(el.dataset.latitude) || 0,
              image: el.dataset.image || ''
            }
          })
        },

        setMap() {
            mapboxgl.accessToken =
                "pk.eyJ1Ijoiam9lcmlldmVycyIsImEiOiJjazl6ZDR3OGgwNW5lM2VwbXJveHp2b3U5In0.Aj-tn3yoSlKVmpoDjhnMLw";
            
            let standardLongitude = document.querySelector('[data-standard-longitude]').dataset.standardLongitude;
            let standardLatitude = document.querySelector('[data-standard-latitude]').dataset.standardLatitude;
            this.center = [standardLongitude, standardLatitude];

            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                this.success.bind(this), 
                this.error.bind(this)
              );
            }

            setTimeout(() => {
              // console.log("center", this.center);
              this.map = new mapboxgl.Map({
                  container: "map",
                  style: "mapbox://styles/mapbox/light-v11",
                  center: this.center,
                  zoom: this.userLocation ? 11 : 6,
              });
              
              this.createMarkers();
              this.setupSearchBox();
      
              setTimeout(() => {
                  this.map.resize();
              }, 200);
            }, 200);
        },

        success(position) {
          this.userLocation = true;
          this.center = [position.coords.longitude.toString(), position.coords.latitude.toString()];
          
          if (this.map) {
            this.map.setCenter(this.center);
            this.map.setZoom(11);
          }
        },
        
        error() {
          let standardLongitude = document.querySelector('[data-standard-longitude]').dataset.standardLongitude;
          let standardLatitude = document.querySelector('[data-standard-latitude]').dataset.standardLatitude;
          this.userLocation = false;
          this.center = [standardLongitude, standardLatitude];
          
          if (this.map) {
            this.map.setCenter(this.center);
          }
        },

        setupSearchBox() {
          // Wait for the map to load before setting up search
          this.map.on('load', () => {
            this.setupExternalSearch();
            this.setupMapMoveListeners();
          });
        },

        setupMapMoveListeners() {
          // Update visible locations when map moves
          this.map.on('moveend', () => {
            this.updateVisibleLocations();
          });
          
          // Initial update of visible locations
          this.updateVisibleLocations();
        },

        updateVisibleLocations() {
          if (!this.map) return;
          
          const bounds = this.map.getBounds();
          const visibleLocations = [];
          
          this.locations.forEach((location, index) => {
            if (location.longitude && location.latitude && 
                !isNaN(location.longitude) && !isNaN(location.latitude)) {
              
              const isVisible = bounds.contains([location.longitude, location.latitude]);
              
              // Update location card visibility
              const locationElement = document.querySelectorAll('[data-location]')[index];
              if (locationElement) {
                if (isVisible) {
                  locationElement.style.display = 'flex';
                  visibleLocations.push(location);
                } else {
                  locationElement.style.display = 'none';
                }
              }
            }
          });
          
          this.visibleLocations = visibleLocations;
        },

        setupExternalSearch() {
          const searchInput = document.getElementById('search-input');
          if (!searchInput) return;
          
          // Create search suggestions container
          const suggestionsContainer = document.createElement('div');
          suggestionsContainer.id = 'search-suggestions';
          // suggestionsContainer.style.display = 'none';
          searchInput.parentNode.style.position = 'relative';
          searchInput.parentNode.appendChild(suggestionsContainer);
          
          let searchTimeout;
          
          // Handle input changes
          searchInput.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            
            clearTimeout(searchTimeout);
            
            if (query.length < 2) {
              // suggestionsContainer.style.display = 'none';
              return;
            }
            
            // Debounce search requests
            searchTimeout = setTimeout(() => {
              this.searchLocations(query);
            }, 300);
          });
          
          // Handle input focus
          searchInput.addEventListener('focus', () => {
            if (searchInput.value.trim().length >= 2) {
              suggestionsContainer.style.display = 'block';
            }
          });
          
          // Handle input blur
          searchInput.addEventListener('blur', () => {
            setTimeout(() => {
              // suggestionsContainer.style.display = 'none';
            }, 200);
          });
        },

        async searchLocations(query) {
          try {
            const response = await fetch(
              `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?` +
              `access_token=${mapboxgl.accessToken}&` +
              `country=NL,BE&` +
              `types=address,poi,place,postcode&` +
              `proximity=${this.center.join(',')}&` +
              `limit=5`
            );
            
            const data = await response.json();
            this.displaySearchSuggestions(data.features || []);
          } catch (error) {
            console.error('Search error:', error);
          }
        },

        displaySearchSuggestions(features) {
          const suggestionsContainer = document.getElementById('search-suggestions');
          const searchInput = document.getElementById('search-input');
          
          if (!suggestionsContainer || !searchInput) return;
          
          if (features.length === 0) {
            suggestionsContainer.style.display = 'none';
            return;
          }
          
          suggestionsContainer.innerHTML = features.map(feature => `
            <div id="search-list-item" class="" 
                 data-lng="${feature.center[0]}" 
                 data-lat="${feature.center[1]}"
                 data-name="${feature.place_name || feature.text}">
              ${feature.place_name || feature.text}
            </div>
          `).join('');
          
          suggestionsContainer.style.display = 'block';
          
          // Add click handlers to suggestions
          suggestionsContainer.querySelectorAll('[data-lng]').forEach(suggestion => {
            suggestion.addEventListener('click', () => {
              const lng = parseFloat(suggestion.dataset.lng);
              const lat = parseFloat(suggestion.dataset.lat);
              const name = suggestion.dataset.name;
              
              // Update input value
              searchInput.value = name;
              suggestionsContainer.style.display = 'none';
              
              // Fly to the selected location
              this.map.flyTo({
                center: [lng, lat],
                zoom: 10.5,
                duration: 2000
              });
            });
          });
        },

        createMarkers() {
          // Clear existing markers
          this.markers.forEach(marker => marker.remove())
          this.markers = []

          // Create a marker for each location
          this.locations.forEach((location, index) => {
            if (location.longitude && location.latitude && 
                !isNaN(location.longitude) && !isNaN(location.latitude)) {
              // Create marker element
              const markerEl = document.createElement('div');
              markerEl.className = 'map-marker';
              markerEl.innerHTML = `
                <i class="fa-solid fa-location-dot text-[30px] text-primary-400"></i>
              `;

              
              // Create and add marker to map
              const marker = new mapboxgl.Marker(markerEl)
                .setLngLat([location.longitude, location.latitude])
                .addTo(this.map);
              
              // Add popup with location info
              // const popup = new mapboxgl.Popup({ offset: 25 })
              //   .setHTML(`
              //     <div class="p-3">
              //       <h3 class="font-semibold text-lg mb-2">${location.name}</h3>
              //       <p class="text-sm text-gray-600 mb-2">${location.address}</p>
              //       <a href="tel:${location.phone}" class="text-primary-400 hover:text-primary-600">${location.phone}</a>
              //     </div>
              //   `);
              
              // marker.setPopup(popup)
              
              // Add click event to marker
              markerEl.addEventListener('click', () => {
                setTimeout(() => {
                  this.highlightLocation(index);
                }, 100);
              })

              let locationCard = this.$root.querySelector(`[data-address="${location.address}"]`);
              locationCard.addEventListener('click', () => {
                this.highlightLocation(index);
              })

              
              this.markers.push(marker);
            }
          })
          
          // Update visible locations after markers are created
          setTimeout(() => {
            this.updateVisibleLocations();
          }, 100);
        },

        highlightLocation(index) {

          // Remove highlight from all location elements
          document.querySelectorAll('[data-location]').forEach(el => {
            el.classList.add('opacity-50');
            el.classList.remove('opacity-100');
          })
          
          // Add highlight to clicked location
          const locationElements = document.querySelectorAll('[data-location]');
          if (locationElements[index]) {
            locationElements[index].classList.add('opacity-100');
            locationElements[index].classList.remove('opacity-50');
            
            // Center the map on the clicked marker
            const location = this.locations[index];
            if (location && location.longitude && location.latitude) {
              this.map.flyTo({
                center: [location.longitude, location.latitude],
                zoom: 10.5,
                duration: 1000
              });
              
              // Update visible locations after map moves
              setTimeout(() => {
                this.updateVisibleLocations();
              }, 1100);
            }
            
            // Scroll to location if it's not visible
            locationElements[index].scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest' 
            })
          }
        },
      }
  }
}